// Brings one local lesson record in line with its delivery on the server.
//
// The delivery is found by `sync_key` and nothing else, so a retry after a lost
// response resolves to the delivery that is already there instead of creating
// a second one.

import repository from "./deliveryRepository";
import { deliveryState, newDelivery } from "./deliveryAdapter";
import { COMPLETED } from "./progressStore";

// Directus rejects a second row with the same unique value; that rejection is
// proof the earlier attempt reached the server.
const isDuplicate = (error) =>
  Array.isArray(error?.errors) &&
  error.errors.some(
    (item) => item?.extensions?.code === "RECORD_NOT_UNIQUE"
  );

// The server is ahead when it already holds a finished delivery: a later
// "in progress" from this device must not undo it.
const bringUpToDate = (existing, record) =>
  existing.status === COMPLETED && record.status !== COMPLETED
    ? existing
    : repository.update(existing.id, deliveryState(record));

const syncDelivery = async ({ record, lessonId, teacherId, classroomId }) => {
  const existing = await repository.find(record.syncKey);
  if (existing) return bringUpToDate(existing, record);

  try {
    return await repository.create(
      newDelivery({ record, lessonId, teacherId, classroomId })
    );
  } catch (error) {
    if (!isDuplicate(error)) throw error;
    const created = await repository.find(record.syncKey);
    if (!created) throw error;
    return bringUpToDate(created, record);
  }
};

export default syncDelivery;
